<!--
/*******************************************************************************
*@ 컴포넌트명   : interestRatesStep2ogauc.vue
*@ 컴포넌트설명 :[오클랜드] 예금 상품 > 금리 안내(정기예금)
*@ 사용전문     :
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2021.10.13   주형진  
********************************************************************************/
-->
<template>
  <div>
    <div class="cont-tit">
      <h6>NZD</h6>
      <div class="tbl-top-etc">{{/*(연이율, 세전, 단위 : %)*/$t("MDEP-01-02-01-08")}}</div>
    </div>
    <table class="table -type01">
      <thead>
        <tr>
          <th class="division" scope="col"></th>
          <th scope="col">
            $5,000
            <em>{{/*이상*/$t("MDEP-01-02-02-14")}}</em>
          </th>
          <th scope="col">
            $10,000
            <em>{{/*이상*/$t("MDEP-01-02-02-14")}}</em>
          </th>
          <th scope="col">
            $50,000
            <em>{{/*이상*/$t("MDEP-01-02-02-14")}}</em>
          </th>
          <th scope="col">
            $100,000
            <em>{{/*이상*/$t("MDEP-01-02-02-14")}}</em>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row">
            7D~1M
            <br />
            {{$t("MDEP-01-02-02-15")}}
          </th>
          <!--7D~1M미만-->
          <td>0.00</td>
          <td>0.00</td>
          <td>0.00</td>
          <td>0.00</td>
        </tr>
        <tr>
          <th scope="row">1M</th>
          <td>0.10</td>
          <td>0.10</td>
          <td>0.20</td>
          <td>0.30</td>
        </tr>
        <tr>
          <th scope="row">2M</th>
          <td>0.10</td>
          <td>0.10</td>
          <td>0.20</td>
          <td>0.30</td>
        </tr>
        <tr>
          <th scope="row">3M</th>
          <td>0.60</td>
          <td>0.60</td>
          <td>0.70</td>
          <td>0.80</td>
        </tr>
        <tr>
          <th scope="row">4M</th>
          <td>1.10</td>
          <td>1.10</td>
          <td>1.20</td>
          <td>1.30</td>
        </tr>
        <tr>
          <th scope="row">5M</th>
          <td>1.30</td>
          <td>1.30</td>
          <td>1.40</td>
          <td>1.50</td>
        </tr>
        <tr>
          <th scope="row">6M</th>
          <td>1.90</td>
          <td>1.90</td>
          <td>2.00</td>
          <td>2.10</td>
        </tr>
        <tr>
          <th scope="row">9M</th>
          <td>1.90</td>
          <td>1.90</td>
          <td>2.00</td>
          <td>2.10</td>
        </tr>
        <tr>
          <th scope="row">1Y</th>
          <td>2.40</td>
          <td>2.50</td>
          <td>2.60</td>
          <td>2.70</td>
        </tr>
        <tr>
          <th scope="row">2Y</th>
          <td>2.80</td>
          <td>2.90</td>
          <td>3.00</td>
          <td>3.10</td>
        </tr>
        <tr>
          <th scope="row">3Y</th>
          <td>2.90</td>
          <td>3.00</td>
          <td>3.10</td>
          <td>3.20</td>
        </tr>
        <tr>
          <th scope="row">4Y</th>
          <td>3.00</td>
          <td>3.10</td>
          <td>3.20</td>
          <td>3.30</td>
        </tr>
        <tr>
          <th scope="row">5Y</th>
          <td>3.10</td>
          <td>3.20</td>
          <td>3.30</td>
          <td>3.40</td>
        </tr>
      </tbody>
    </table>
    <div class="info info-etc">{{/*중도해지 : 약정이율 –2% 이거나 0%*/$t("MDEP-01-02-02-07")}}</div>
    <div class="cont-tit">
      <h6>USD</h6>
      <div class="tbl-top-etc">{{/*(연이율, 세전, 단위 : %)*/$t("MDEP-01-02-01-08")}}</div>
    </div>
    <table class="table -type01">
      <thead>
        <tr>
          <th class="division" scope="col"></th>
          <th scope="col">
            $5,000
            <em>{{/*이상*/$t("MDEP-01-02-02-14")}}</em>
          </th>
          <th scope="col">
            $10,000
            <em>{{/*이상*/$t("MDEP-01-02-02-14")}}</em>
          </th>
          <th scope="col">
            $50,000
            <em>{{/*이상*/$t("MDEP-01-02-02-14")}}</em>
          </th>
          <th scope="col">
            $100,000
            <em>{{/*이상*/$t("MDEP-01-02-02-14")}}</em>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row">31{{/*일*/$t("MDEP-01-02-02-16")}}</th>
          <td>0.00</td>
          <td>0.00</td>
          <td>0.00</td>
          <td>0.00</td>
        </tr>
        <tr>
          <th scope="row">61{{/*일*/$t("MDEP-01-02-02-16")}}</th>
          <td>0.10</td>
          <td>0.10</td>
          <td>0.10</td>
          <td>0.30</td>
        </tr>
        <tr>
          <th scope="row">92{{/*일*/$t("MDEP-01-02-02-16")}}</th>
          <td>0.10</td>
          <td>0.10</td>
          <td>0.30</td>
          <td>0.50</td>
        </tr>
        <tr>
          <th scope="row">183{{/*일*/$t("MDEP-01-02-02-16")}}</th>
          <td>0.10</td>
          <td>0.30</td>
          <td>0.50</td>
          <td>0.80</td>
        </tr>
      </tbody>
    </table>
    <div class="info info-etc">{{/*중도해지 : 약정이율 –2% 이거나 0%*/$t("MDEP-01-02-02-07")}}</div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      currentTab: 1,
    };
  },
};
</script>